import { render } from "./PayrollPeriodView.vue?vue&type=template&id=01829815&scoped=true"
import script from "./PayrollPeriodView.vue?vue&type=script&lang=js"
export * from "./PayrollPeriodView.vue?vue&type=script&lang=js"

import "./PayrollPeriodView.vue?vue&type=style&index=0&id=01829815&scoped=true&lang=css"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01829815"]])

export default __exports__